import { useEffect, useState } from 'react';

type CarouselComponent = typeof import('../CarouselWrapper').default;

const useCarousel = (itemCount: number, hasGeneratedVideo: boolean) => {
  const [CarouselComponent, setCarouselComponent] = useState<CarouselComponent>();

  useEffect(() => {
    let active = true;
    import(/* webpackChunkName: "carousel" */ '../CarouselWrapper').then(({ default: component }) => {
      if (active) setCarouselComponent(() => component);
    });
    return () => {
      active = false;
    };
  }, []);

  return {
    CarouselComponent,
    showCarousel: Boolean(CarouselComponent) && (itemCount > 1 || hasGeneratedVideo),
  };
};

export default useCarousel;
